/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetRiderTabs200Response,
} from '../models/index';
import {
    GetRiderTabs200ResponseFromJSON,
    GetRiderTabs200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class TabsApi extends runtime.BaseAPI {

    /**
     */
    async getRiderTabsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRiderTabs200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tabs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRiderTabs200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getRiderTabs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRiderTabs200Response> {
        const response = await this.getRiderTabsRaw(initOverrides);
        return await response.value();
    }

}
